import React from 'react';
import RecordDispatchHost from '../pages/Sales/dispatches/RecordDispatchHost';

// Record Dispatch as a CreateDrawerHost form (draft persistence: a dirty form that is closed collapses to the top-right pill and keeps its state until Save / Discard).
// Context via params, same semantics as before: operationId = order LOCKED; partnerId / partnerName = customer LOCKED + only that customer's dispatchable orders;
// the global + Create menu passes none (free order picker).
export default function DispatchDoorForm({ size, onSize, onClose, onInteract, params }) {
  return <RecordDispatchHost embed={{ size, onSize }} initialOrder={params?.operationId || ''} partnerId={params?.partnerId || ''} partnerName={params?.partnerName || ''}
    onClose={onClose} onChanged={() => window.dispatchEvent(new Event('dispatches-changed'))} onDirty={onInteract} />;
}
